import React from 'react';

const ImageModal = ({ imageUrl, title, onClose }) => {
  if (!imageUrl) return null;

  return (
    <div 
      className="fixed inset-0 bg-black flex items-center justify-center z-50"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-6 right-6 text-white hover:text-gray-300 text-4xl font-bold z-10 bg-black/50 rounded-full w-16 h-16 flex items-center justify-center"
      >
        ×
      </button>
      <img
        src={imageUrl}
        alt={title || 'Full resolution image'}
        className="max-w-[95vw] max-h-[95vh] object-contain"
        onClick={(e) => e.stopPropagation()}
      />
      {title && (
        <div className="absolute bottom-6 left-6 right-6 bg-black/80 text-white p-4 rounded-lg text-center">
          <h3 className="font-medium text-xl">{title}</h3>
          <p className="text-sm text-gray-300 mt-1">Full Resolution • Click outside to close • ESC to exit</p>
        </div>
      )}
    </div>
  );
};

export default ImageModal;